import axios from 'axios';

export default {
  fetchAffiliateList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/affiliate', {
      params: paginationParams,
    })
      .then((affiliates) => {
        commit('setData', affiliates);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteAffiliate(_, affiliate) {
    return axios.delete(`/affiliate/${affiliate.id}`);
  },
};
